<template>  
  <v-list-item class="px-2" @click="leadClick(lead)">
    <StatusIcon status="disputed" />
    <div class="flex-grow-1 pl-3" style="font-size: 14px">
      <div class="d-flex">
        <div><strong>{{ lead.customer.name }} - Disputed</strong></div>
        <div class="ml-auto text-body-2 grey--text">
          {{ formatDate(lead.lead_date) }}
        </div>
      </div>
      
      <div class="d-flex">
        <div class="mr-auto">{{ lead.service }}</div>
        <div>{{ lead.friendly_structure_type }}</div>
      </div>
    </div>
  </v-list-item>
</template>

<script>
import StatusIcon from '@/components/StatusIcon'
import formatters from '@/lib/formatters'

export default {
  name: 'DisputedLead',

  props: {
    lead: {
      type: Object,
      required: true,
    },
  },

  components: { StatusIcon },  

  methods: {
    ...formatters,

    leadClick(lead) {
      this.$router.push( { name: 'leads', params: { lead_id: lead.lead_id }})
    },
  },
}
</script>